import manifest from "./handbuchManifest.json";

export interface HandbuchVersion {
  version: string;
  date: string; // ISO-Datum der Freigabe
  status: string; // "aktuell" | "archiviert"
  author: string;
  summary: string;
  changes: string[];
  /** Unveränderliche, versionierte PDF-Datei (Download-Historie) */
  pdf: string;
}

/**
 * Versionshistorie des Handbuchs – automatisch gepflegt von
 * scripts/generate-handbuch-pdf.mjs (läuft bei Dev-Start und bei jedem Build).
 * Inhalt wird ausschließlich in src/data/handbuchContent.json bearbeitet.
 */
export const handbuchVersions: HandbuchVersion[] = manifest.versions as HandbuchVersion[];

export const currentHandbuchVersion: HandbuchVersion = handbuchVersions[0];

/** Immer die zuletzt erzeugte Fassung */
export const currentHandbuchPdf = "/downloads/eap-handbuch-homepage.pdf";

export const handbuchGeneratedAt: string = manifest.generatedAt;

export const formatHandbuchDate = (iso: string) =>
  new Date(iso).toLocaleDateString("de-AT", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
